var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconesAreas05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124 160",
    style: {
      enableBackground: "new 0 0 124 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,53.1c-2.4,2.5-4.7,5.2-7.3,7.5c-1.2,1-3.2,1.8-4.6,1.6c-2.7-0.4-3.5-4-1.4-6.2c4.9-5.1,9.9-10.1,15-15 c1.7-1.7,3.9-1.7,5.6,0c5.1,4.9,10.1,10,15,15c1.7,1.7,1.8,3.8,0,5.5c-1.8,1.8-3.8,1.4-5.5-0.3c-2.6-2.6-5.1-5.2-8.4-8.6 c0,3.9,0,7,0,10c-0.1,7-2,13.5-6.3,19.1C96.5,89.3,88.8,93.5,79,93.9c-3.2,0.1-5.1-1.2-5.2-3.6c-0.1-2.3,1.9-4,5-4.1 c9.6-0.1,18.5-6.8,21-15.8c1.5-5.4,1.3-11.2,1.9-16.8C101.2,53.5,100.8,53.3,100.3,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.9,15.4C89.8,7.1,96.7,0,104.9,0c8.1,0,15.1,7,15.1,15.1c0.1,8.3-6.9,15.4-15.1,15.4 C96.8,30.6,90,23.7,89.9,15.4z M97.5,15.1c-0.1,4.2,3.2,7.7,7.3,7.8c4,0.1,7.6-3.5,7.7-7.5c0-4-3.5-7.5-7.6-7.5 C100.7,7.9,97.6,11,97.5,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,144.7c0-8.4,6.9-15.4,15.1-15.3c8.1,0.1,14.9,7,14.9,15.2c0,8.4-6.9,15.4-15.1,15.3 C6.8,159.9,0,153,0,144.7z M7.5,144.8c0.1,4.2,3.5,7.5,7.7,7.4c4-0.1,7.3-3.5,7.3-7.5c0-4-3.5-7.6-7.6-7.5 C10.8,137.2,7.5,140.6,7.5,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,54.1c2.8,2.7,5.3,5,7.7,7.5c2.3,2.3,2.6,4.6,0.6,6.2c-2.2,1.8-4.2,1.2-6-0.7c-2.4-2.4-4.8-4.9-7.7-7.8 c-2.5,2.6-4.8,5.1-7.2,7.6c-2.2,2.2-4.7,2.6-6.3,1c-1.8-1.7-1.5-4.2,0.9-6.5c2.4-2.3,4.8-4.6,7.8-7.4c-2.8-2.6-5.4-4.8-7.8-7.2 c-2.3-2.2-2.6-4.6-1-6.3c1.6-1.7,4.2-1.4,6.5,0.9c2.3,2.4,4.5,4.8,7.2,7.7c2.7-2.9,5-5.4,7.4-7.8c2.2-2.2,4.6-2.5,6.3-0.9 c1.8,1.8,1.6,3.9-0.8,6.2C55,49,52.5,51.4,49.8,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110,117.3c2.9,2.8,5.4,5.2,7.8,7.6c2.1,2.1,2.3,4.5,0.7,6c-1.6,1.5-4.1,1.3-6.1-0.6c-2.4-2.4-4.8-4.9-7.5-7.7 c-2.5,2.4-4.7,4.7-7,6.9c-0.8,0.8-1.7,2-2.6,2.1c-1.6,0-3.6-0.3-4.6-1.3c-1.6-1.5-0.9-3.5,0.6-5c2.6-2.6,5.4-5.2,8.5-8.1 c-2.9-2.7-5.4-5-7.8-7.4c-2.4-2.4-2.7-4.4-1-6.2c1.7-1.8,3.9-1.6,6.2,0.7c2.4,2.4,4.7,5,7.6,7.9c2.7-2.9,5-5.5,7.5-8 c2.3-2.3,4.7-2.5,6.2-0.6c1.7,2.2,1.1,4.3-0.8,6.1C115.4,112.2,112.9,114.6,110,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.2,137.5c3.1,2.9,5.6,5.4,8.1,7.9c2.1,2.1,2.3,4.4,0.5,6c-2,1.8-4,1.3-5.8-0.5c-2.5-2.5-4.9-5.1-7.7-7.8 c-2.8,2.8-5.4,5.4-8.1,7.9c-2.2,2-4.6,2-6,0c-1.4-2-1-3.9,0.7-5.6c2.5-2.5,5.1-4.9,8.1-7.9c-2.6-2.5-5.1-4.8-7.5-7.2 c-2.5-2.5-2.8-4.7-1-6.5c1.7-1.7,4.1-1.3,6.5,1.2c2.3,2.3,4.5,4.6,7.1,7.4c2.7-2.8,5.1-5.2,7.5-7.8c1.8-1.9,3.9-2.5,6-0.8 c2,1.5,1.7,3.9-0.5,6.2C68.6,132.6,66,134.9,63.2,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.1,94c-2.2-0.2-3.8-1.5-3.8-3.7c0-2.3,1.6-3.8,3.7-3.8c2.2,0,3.7,1.2,3.7,3.7C65.8,92.6,64.4,93.7,62.1,94z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,96.3c-2.3-0.1-3.7-1.2-3.8-3.5c-0.1-2.3,1.2-3.7,3.4-3.9c2-0.2,4.2,1.7,4,3.7 C34.8,94.7,33.7,96.1,31.3,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,106.3c-2.5-0.1-3.9-1.3-4-3.6c-0.1-2.4,1.4-3.7,3.6-3.8c2.3-0.1,3.7,1.4,3.8,3.6 C23.2,104.8,21.8,106,19.7,106.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.1,90.4c-0.1,2.2-1.4,3.6-3.7,3.6c-2.3,0-3.8-1.5-3.8-3.7c0-2.2,1.6-3.8,3.8-3.8 C48.6,86.5,50.1,87.8,50.1,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,113.6c2.2,0.4,3.6,1.6,3.4,4c-0.2,2.3-1.8,3.6-4,3.5c-2.1-0.2-3.6-1.6-3.4-4 C11.5,114.7,13,113.7,15.3,113.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesAreas05);
export default __webpack_public_path__ + "static/media/IconesAreas05.e0ce014ef4cba428e80aed7dbcb01778.svg";
export { ForwardRef as ReactComponent };